var map = {
	"./add_to_list.svg": 90260,
	"./add_to_list_white.svg": 81646,
	"./ajax-loading.svg": 61071,
	"./alert-icon.svg": 67982,
	"./archive-01.svg": 35752,
	"./arrow-01.svg": 23943,
	"./brokenheart-01.svg": 21057,
	"./brokenheart-02.svg": 16018,
	"./brokenheart-03.svg": 19331,
	"./cabinetSearch.svg": 2922,
	"./camera-01.svg": 71761,
	"./carousel-control-left.svg": 60562,
	"./carousel-control-right.svg": 29897,
	"./check-mark.svg": 9196,
	"./checkbox-checked.svg": 37889,
	"./checkbox-unchecked.svg": 25646,
	"./circle-01.svg": 71426,
	"./close-alt.svg": 66076,
	"./close-rows.svg": 7352,
	"./close.svg": 95334,
	"./collapsible-arrow.svg": 79618,
	"./cost-model-01.svg": 18663,
	"./cost-model-02.svg": 47156,
	"./cost-model-03-white.svg": 76745,
	"./cost-model-03.svg": 89141,
	"./cost-model-04.svg": 62378,
	"./cube.svg": 87705,
	"./cupid-logo.svg": 91107,
	"./cupid_icon.png": 82092,
	"./cupid_icon_red.png": 25428,
	"./cupid_icon_white.png": 54858,
	"./cupid_logo.png": 34346,
	"./deviation-example-misc.png": 6916,
	"./dollar-icon.png": 82169,
	"./edit_list_item.svg": 10381,
	"./error-icon-2.svg": 59531,
	"./error-icon-3.svg": 82010,
	"./error-icon-4.svg": 89189,
	"./error-icon.svg": 49610,
	"./expand-rows.svg": 47560,
	"./facebook-icon.png": 67783,
	"./facebook.svg": 74574,
	"./favicon.ico": 44791,
	"./favicon/android-chrome-144x144.png": 48893,
	"./favicon/android-chrome-192x192.png": 96725,
	"./favicon/android-chrome-36x36.png": 80059,
	"./favicon/android-chrome-48x48.png": 88965,
	"./favicon/android-chrome-72x72.png": 16275,
	"./favicon/android-chrome-96x96.png": 80307,
	"./favicon/apple-touch-icon-114x114.png": 40149,
	"./favicon/apple-touch-icon-120x120.png": 61069,
	"./favicon/apple-touch-icon-144x144.png": 6257,
	"./favicon/apple-touch-icon-152x152.png": 9897,
	"./favicon/apple-touch-icon-180x180.png": 17113,
	"./favicon/apple-touch-icon-57x57.png": 40153,
	"./favicon/apple-touch-icon-60x60.png": 15117,
	"./favicon/apple-touch-icon-72x72.png": 4871,
	"./favicon/apple-touch-icon-76x76.png": 46279,
	"./favicon/apple-touch-icon-precomposed.png": 96714,
	"./favicon/apple-touch-icon.png": 47674,
	"./favicon/browserconfig.xml": 99141,
	"./favicon/favicon-16x16.png": 67861,
	"./favicon/favicon-194x194.png": 25067,
	"./favicon/favicon-32x32.png": 52613,
	"./favicon/favicon-96x96.png": 52501,
	"./favicon/favicon.ico": 83046,
	"./favicon/manifest.json": 26887,
	"./favicon/mstile-144x144.png": 28433,
	"./favicon/mstile-150x150.png": 64973,
	"./favicon/mstile-310x150.png": 16227,
	"./favicon/mstile-310x310.png": 4017,
	"./favicon/mstile-70x70.png": 26075,
	"./favicon/safari-pinned-tab.svg": 65558,
	"./filter-01.svg": 96820,
	"./filter-close-alt.svg": 51457,
	"./filter-close.svg": 28079,
	"./filter-dropdown-close.svg": 83029,
	"./filter-dropdown-config.svg": 79417,
	"./filter-dropdown.svg": 12922,
	"./filter-label-image-config.svg": 23300,
	"./filter-label-image.svg": 17313,
	"./filter-submit-image.svg": 97569,
	"./fire-icon.png": 30039,
	"./fist-icon.png": 38441,
	"./gameSearch.svg": 79656,
	"./gmaps.png": 14055,
	"./grad.png": 95605,
	"./graphic-example-misc.png": 2627,
	"./heart-01.svg": 93686,
	"./heart-02.svg": 30325,
	"./heart-03.svg": 92340,
	"./help-black.svg": 14309,
	"./help.png": 48204,
	"./help.svg": 18459,
	"./horse-icon.png": 82090,
	"./icon-facebook.svg": 73794,
	"./icon-instagram.svg": 25382,
	"./icon-linkedin.svg": 81272,
	"./icon-twitter.svg": 15231,
	"./icon.svg": 16665,
	"./icon_help_pane.png": 53053,
	"./information-icon.png": 32973,
	"./instagram.svg": 31098,
	"./instructions_popup_overview.png": 66043,
	"./issues.svg": 16846,
	"./kpi-01.svg": 89080,
	"./linkedin.svg": 78524,
	"./mail.svg": 10967,
	"./menu.svg": 48139,
	"./noplatform.png": 81729,
	"./padlock-lock.svg": 30904,
	"./padlock-unlock.svg": 50661,
	"./phone.svg": 9738,
	"./plus-01.svg": 5518,
	"./query-01.svg": 28846,
	"./question-mark-01.svg": 65544,
	"./reel-metrics-logo-beta.svg": 53713,
	"./reel-metrics-logo-white.svg": 69534,
	"./reel-metrics-logo.svg": 1586,
	"./reelcast.svg": 24723,
	"./reelmetrics-logo-beta.png": 30317,
	"./reelmetrics-logo.png": 9388,
	"./report-01.svg": 36472,
	"./rm_icon_reelquick.svg": 47023,
	"./sample-sankey.svg": 55354,
	"./save_list.svg": 61972,
	"./savereport-01.svg": 65065,
	"./search.svg": 28874,
	"./slider_icon.png": 34144,
	"./sorting.png": 83785,
	"./sorting_asc.png": 16959,
	"./sorting_desc.png": 97497,
	"./success-icon.svg": 92423,
	"./suppliers/ags.svg": 22311,
	"./suppliers/ainsworth.svg": 68641,
	"./suppliers/aristocrat.svg": 92418,
	"./suppliers/aruze.png": 76298,
	"./suppliers/bally.svg": 94436,
	"./suppliers/bluberi.png": 77484,
	"./suppliers/everi.svg": 17793,
	"./suppliers/gaming-arts.png": 67873,
	"./suppliers/igt-everi.svg": 33558,
	"./suppliers/igt.svg": 93440,
	"./suppliers/incredible-technologies.png": 80815,
	"./suppliers/interblock.svg": 96205,
	"./suppliers/konami.svg": 44447,
	"./suppliers/light-and-wonder.svg": 14544,
	"./suppliers/novomatic.svg": 82886,
	"./suppliers/wms.png": 4028,
	"./suppliers/zitro.svg": 23476,
	"./throbber.gif": 27058,
	"./thumbs-down-01.svg": 32818,
	"./thumbs-down-02.svg": 14561,
	"./thumbs-down-03.svg": 99760,
	"./thumbs-up-01.svg": 59239,
	"./thumbs-up-02.svg": 87732,
	"./thumbs-up-03.svg": 29717,
	"./traingle-01.svg": 13370,
	"./twitter.svg": 94827,
	"./undo_list_2.svg": 76196,
	"./user.svg": 54603,
	"./vanilla_ice_cream.jpg": 44707,
	"./wrench.svg": 86189
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82672;